import React, { useState, useEffect } from 'react';
import Config from '../Config'
import axios from 'axios';
import Pagination from '../layout/Pagination';
import { Route, Link, Switch, BrowserRouter as Router } from 'react-router-dom'
import logos from '../layout/pageheader.jpeg'
import _ from 'lodash'

export const FAQ = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(6);

    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            const res = await axios.get(new Config().BaseURL() + 'category/fetchallknowledgebase/FAQ');
            setPosts(res.data);
            setLoading(false);
        };

        fetchPosts();
    }, []);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    
    const paginate = pageNumber => setCurrentPage(pageNumber);
    return (
        <div>
            

            <div class="hero-section bg_imgs" style={{backgroundImage:`url(${logos})`}}>
                <div class="container">
                    <div class="banner-content cl-white">
                        <ul class="breadcrumb">
                            <li><a href="#/">Home</a></li>
                            <li>FAQ</li>
                        </ul>
                    </div>
                </div>
            </div>


            <section class="knowledge-section padding-bottom padding-top">
                <div class="container">
                    <div class="section-header">
                        <h2 class="title">Frequently Ask Questions</h2>
                        <p>Explore How-To's and learn best practices from our FAQ.</p>
                    </div>
                    <div class="row justify-content-center mb-30-none">
                        {(posts =='')?<span className='fa fa-spinner fa-spin'></span>:
                            currentPosts.map(itm =>

                                <div class="col-lg-6 col-md-10">
                                     {/* <Link  to={"/answers/" + itm.id + "/" + itm.subject.replace(/ /g, '-')}> */}
                                    <div class="knowledge-item">
                                        <div class="knowledge-thumb">
                                            <img src="./assets/images/knowledge/know1.png" alt="knowledge" />
                                        </div>
                                        <div class="knowledge-content">
                                            <h4 class="title"><a href={"#/answers/" + itm.id + "/" + itm.subject.replace(/ /g, '-')}> {_.truncate(itm.subject, { 'length': 50, 'separator': ' '})}</a></h4>
                                            {/* <p style={{color:"#372c7a"}}>{_.truncate(itm.message, { 'length': 83, 'separator': ' '})} </p> */}
                                        </div>
                                    </div>
                                    {/* </Link> */}
                                </div>
                            )
                        }

                    </div>
                </div>
                <br></br>
                <span>Total Articles  {posts.length} &nbsp;</span>
                        <Pagination
                            postsPerPage={postsPerPage}
                            totalPosts={posts.length}
                            paginate={paginate}
                        />
            </section>
           


        
          
        </div>
    )
}
